import React from 'react';

const SimpleHeader = () => {
  return (
    <div style={{
      padding: '15px 20px',
      borderBottom: '1px solid #e5e7eb',
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center'
    }}>
      <a 
        href="/" 
        style={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          color: '#374151'
        }}
      >
        {/* Home icon (SVG) */}
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          style={{ marginRight: '8px' }}
        >
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
        <span style={{ fontWeight: 'bold', fontSize: '16px' }}>Civil Claims Registry</span>
      </a>
    </div>
  );
};

export default SimpleHeader;